<template>
  <v-dialog
    content-class="dialogText"
      v-model="isDialog"
      style="z-index: 600;"
      max-width="800"
      :light="true"
  >
    <v-card v-if="isDialog">
      <div class="absX" @click.passive="closeDialog">
        <v-icon x-large class="myGray">mdi-window-close</v-icon>
      </div>
      <div class="spacer-25"></div>

      <div class="pa-7">
        <v-container grid-list-lg>
          <h3>Wähle deine ungefähre Ankunftszeit aus</h3>
          <v-layout row wrap class="pt-5">
            <v-flex xs12 md3>
              <div class="d-flex flex-nowrap flex-md-wrap">
                <h4 class="flex-shrink-0 flex-grow-0 flex-md-grow-1 mr-2 breakTitle text-no-wrap labelTimeSelection"
                >Datum:</h4>
                <v-select hide-details :items="abholDatumArray" item-text="value" v-model="selectedAbholDatum"
                          return-object illed></v-select>
              </div>
            </v-flex>
            <v-flex xs12 md1 class="hidden-sm-and-down">
            </v-flex>
            <v-flex xs12 md4>

              <div class="d-flex flex-nowrap flex-md-wrap">
                <h4 class="flex-shrink-0 flex-grow-0 flex-md-grow-1 mr-2 breakTitle text-no-wrap labelTimeSelection"
                >Ankunftszeit:</h4>
                <v-select v-if="selectedAbholDatum.value === 'Heute'" hide-details :items="timesToday"
                          item-text="display" v-model="time" :class="{selectBlinker: !(time && time.value)}"
                          return-object illed
                          placeholder="Uhrzeit auswählen"></v-select>
                <v-select v-if="selectedAbholDatum.value === 'Morgen'" hide-details :items="timesTomorrow"
                          item-text="display" v-model="time" :class="{selectBlinker: !(time && time.value)}"
                          return-object illed
                          placeholder="Uhrzeit auswählen"></v-select>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </div>

      <v-card-actions>
        <v-spacer></v-spacer>

        <div class="mr-4 underline text-center">
          <span @click.passive.stop="closeDialog" class="pointer">Abbrechen</span>
        </div>

        <v-btn
            text
            class="btn-df"
            @click.native.passive="doProcess"
        >
          Weiter
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>

import {setGlobalKeyValue} from "../util/globalState";
import * as util from "../vendor/util";
import store from "../store/store";
import {ebus} from "../vendor/ebus";
import {
  calcDelayInMinutes,
  calculateZielterminOfToday,
  cloneMe,
  generatePickupDate,
  getDayOfWeek
} from "../vendor/util";

export default {
  props: {
    dialog: Boolean,
  },
  data() {
    return {
      isDialog: false,

      //abholung öffnungszeiten
      abholDatumArray: [{
        value: 'Heute'
      },
        {
          value: 'Morgen'
        }
      ],
      selectedAbholDatum: {
        value: 'Heute'
      }, //default
      time: null, //{value:'06:45', utc:...}//produces a string i.e. 06:45
      timesToday: [
        //{
        //     value: h + ':' + minute,
        // display: 'ca. ' + h + ':' + minute + ' Uhr',
        // utc: utcValue.getTime()
        // }
      ],
      timesTomorrow: [
        //{
        //     value: h + ':' + minute,
        // display: 'ca. ' + h + ':' + minute + ' Uhr',
        // utc: utcValue.getTime()
        // }
      ],
    }
  },
  watch: {
    dialog(newValue) {
      this.isDialog = newValue;
      if (newValue) {
        this.reset();
        this.initTimesArray();
      }
    },
    isDialog(newValue) {
      if (!newValue) {
        // this.ready = false;
        this.$emit('close');
      }
    }
  },

  computed: {
    userSelectedHeute() {
      return this.selectedAbholDatum.value === 'Heute';
    },
  },

  methods: {
    reset() {
      this.selectedAbholDatum = {
        value: 'Heute'
      };
      this.time = null;
    },
    doProcess(event) {
      this.finishSelection();
    },
    closeDialog() {
      this.reset();
      this.isDialog = false;
      this.$emit('close');
    },

    calcEarliestAbholung() {
      let delayInMinutes = calcDelayInMinutes(store.getters.appconfig.takeAway.delayInMinutes, cloneMe(store
          .getters.cartItems));
      return calculateZielterminOfToday(delayInMinutes); // returns a Date
    },

    initTimesArray() {
      console.log('initTimesArray...');
      let appconfig = cloneMe(store.getters.appconfig);
      if (!appconfig.takeAway.openingHours['1']) {
        //XHR has not finished loading the appconfig yet
        return;
      }
      //init times array
      this.timesToday.splice(0, this.timesToday.length);
      this.timesTomorrow.splice(0, this.timesTomorrow.length);

      //takwaways either on today or tomorrow so we need to filter the hours
      let allHours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
      // let allMinutes = ['00', '15', '30', '45'];
      // let moreMinutes = ['00', '5', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];

      //calculate delayInMinutes
      let delayInMinutes = calcDelayInMinutes(appconfig.takeAway.delayInMinutes, cloneMe(store.getters
          .cartItems));

      //Init Heute timesToday
      // this.internalDaySelected = '1';
      let today = getDayOfWeek(new Date());
      let ohsToday = appconfig.takeAway.openingHours['' + today];
      // console.log('openedToday = '+ohsToday.opened);
      if (ohsToday.opened) {
        let relevantHours = allHours.filter((h) => {
          return this.allowedHours(h, ohsToday)
        });

        if (relevantHours) {
          // let nextDay = util.getNextDay();
          let rNow = new Date();
          let currentHour = rNow.getHours();
          let currentMinutes = rNow.getMinutes();
          let earliestAbholung = this.calcEarliestAbholung();
          // console.log('???? earliestAbholung utc = ' + earliestAbholung.getTime());

          for (let hour of relevantHours) {

            //ignore hours before zieltermin
            if (hour < earliestAbholung.getHours()) {
              continue;
            }

            let h = '' + hour;
            if (hour < 10) {
              h = '0' + h;
            }

            this.generateMinutes(delayInMinutes, h, hour, currentHour, currentMinutes, ohsToday, this.timesToday,
                true);
          } //eof of init today
        }

      }
      if (this.timesToday.length > 0) {
        this.abholDatumArray[0].value = 'Heute';
      } else {
        this.abholDatumArray[0].value = 'Heute geschlossen';
      }


      //init Morgen timesTomorrow
      // this.internalDaySelected = '1';
      let tomorrow = util.getNextDay();
      let ohsTomorrow = appconfig.takeAway.openingHours['' + tomorrow];
      if (ohsTomorrow.opened) {
        let relevantHours2 = allHours.filter((h) => {
          return this.allowedHours(h, ohsTomorrow)
        });
        // let nextDay = util.getNextDay();
        //     let rNow = new Date();
        //     let currentHour = rNow.getHours();
        //     let currentMinutes = rNow.getMinutes();
        // let zieltermin = calculateZielterminOfToday(appconfig.takeAway.delayInMinutes);
        if (relevantHours2) {
          for (let hour of relevantHours2) {

            //ignore hours before zieltermin
            // if (hour < zieltermin.getHours()) {
            //         continue;
            //       }

            let h = '' + hour;
            if (hour < 10) {
              h = '0' + h;
            }

            this.generateMinutes(delayInMinutes, h, hour, null, null, ohsTomorrow, this.timesTomorrow, false);


          } //eof of init tomorrow
        }


      }
      if (this.timesTomorrow.length > 0) {
        this.abholDatumArray[1].value = 'Morgen';
      } else {
        this.abholDatumArray[1].value = 'Morgen geschlossen';
      }


      // this.preselectDay1();
    },

    generateMinutes(delayInMinutes, h, hour, currentHour, currentMinutes, ohs, timesArray, forToday) {
      try {
        let lessMinutes = ['00', '15', '30', '45'];
        let allMinutes = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];
        for (let minute of allMinutes) {
          let _minute = parseInt(minute, 10);

          let utcValue;
          if (forToday) {
            utcValue = new Date();
          } else {
            utcValue = util.addDays(util.getCurrentRemoteTime(), 1);
          }
          // console.log('checkout utc = ' + nd.getTime());
          // console.log('checkout utc date = ' + nd);
          // console.log('checkout utc locale = ' + nd.toLocaleString());
          utcValue.setHours(hour);
          utcValue.setMinutes(_minute);
          let diff2Now = utcValue.getTime() - Date.now();
          let isWithin60Minutes = diff2Now < (1000 * 60 * 60);
          if (isWithin60Minutes || forToday) {
            //ignore times if delayInMinutes from now is too small
            if (diff2Now < (delayInMinutes * 60 * 1000)) {
              continue;
            }
          }

          if (forToday) {
            if (hour === currentHour) {
              //ignore minutes before now
              if (_minute <= currentMinutes) {
                continue;
              }
            }
          }

          if (!isWithin60Minutes) {
            if (!lessMinutes.includes(minute)) {
              continue; //less minutes for everything later than 60 minutes
            }
          }

          if (hour === ohs.a.fromHour) {
            if (!(ohs.a.fromMinute <= _minute)) {
              continue
            }
          }
          if (hour === ohs.a.tillHour) {
            if (!(_minute <= ohs.a.tillMinute)) {
              continue
            }
          }
          if (hour === ohs.b.fromHour) {
            if (!(ohs.b.fromMinute <= _minute)) {
              continue
            }
          }
          if (hour === ohs.b.tillHour) {
            if (!(_minute <= ohs.b.tillMinute)) {
              continue
            }
          }

          timesArray.push({
            value: h + ':' + minute,
            display: 'ca. ' + h + ':' + minute + ' Uhr',
            utc: utcValue.getTime()
          });
        }
      } catch (e) {
        ebus.$emit('throwError', getErrorDetails('Exception in generateMinutes: ' + e.message));
      }
    },

    allowedHours(h, dayOh) {
      // let rNow = Date.now();
      // let currentHour = rNow.getHours();

      // if (isToday) {
      //     //ignore hours before now
      //     if (h < currentHour) {
      //         return false;
      //     }
      // }
      //check period a
      let matchesA = dayOh.a.fromHour <= h && h <= dayOh.a.tillHour;
      if (matchesA) {
        return true;
      }
      if (dayOh.b.fromHour > -1 && dayOh.b.fromHour !== dayOh.b.tillHour) {
        return dayOh.b.fromHour <= h && h <= dayOh.b.tillHour;
      }
      return false;
    },

    finishSelection() {
      if (!this.time) {
        ebus.$emit('toast', 'Bitte wähle zuerst deine ungefähre Ankunftszeit aus');
        return;
      }
      let dayParam = this.userSelectedHeute ? '1' : '2';
      let pickupDate = generatePickupDate(dayParam, cloneMe(this.time));
      // let targetTime: this.pickupDate.utc;

      this.$ls.set('userSelectedTargetTime', pickupDate);

      ebus.$emit('cb-finishPickupTimeSelection');

      this.closeDialog()
    }

  }
}
</script>

<style lang="scss" scoped>
.labelTimeSelection {
  min-width: 90px;
}
</style>
